import Features from "../page/Feature";

const FeaturesSection = () => {
    return (
        <section
            id="features"
            data-section
            data-title="Features"
            aria-label="Features"
            className="relative w-full min-h-screen"
        >
            <Features />
        </section>
    );
};

export default FeaturesSection;
